<div class="step-box">
	<div class="row">
		<div class="col-md-12 align-left">
			<span jhiTranslate="multi-trait-query.panel.select.traits.comment">Get all values for numeric variates</span>
		</div>
	</div>
	<br>
	<div class="col-sm-6">
		<div class="input-group mb-6">
			<span class="input-group-text" id="filter-traits">
				<i class="fa fa-search"></i>
			</span>
			<input [(ngModel)]="textFilter" [placeholder]="traitFilterPlaceHolder | translate" class="form-control"
				   id="textSearch" name="textSearch" type="text">
			<button (click)="textFilter=''" *ngIf="textFilter" aria-label="Clear" class="btn btn-outline-secondary">
				<i class="fa fa-times"></i>
			</button>
		</div>
	</div>
	<div class="trait-grid">
		<div class="col-sm-6">
			<div class="panel panel-primary">
				<div class="panel-heading"><span
					jhiTranslate="multi-trait-query.panel.select.traits.header.trait"></span></div>
				<div class="trait-tree custom-scroll-style">
					<div class="panel-wrapper">
						<div class="panel-body">
							<jhi-trait-tree (onAddSelectedTrait)="addSelectedTrait($event)"
											[isLevelZero]="true" [textFilter]="textFilter"
											[traitReferences]="traitReferences"></jhi-trait-tree>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-sm-6">
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-curved">
					<thead>
					<tr>
						<th>
							<span jhiTranslate="multi-trait-query.panel.select.traits.header.trait.name"></span>
						</th>
						<th>
							<span jhiTranslate="multi-trait-query.panel.select.traits.header.standard.variable.name"></span>
						</th>
					</tr>
					</thead>
					<tbody *ngIf="selectedTraits.length else nodata">
					<tr *ngFor="let trait of selectedTraits ">
						<td>{{ trait.parent.name }}</td>
						<td>
							<div class="align-items-center">
								<button (click)="deleteTrait(trait)"
										class="btn btn-sm btn-outline-danger justify-content-end">
									<span class="fa fa-times-circle"></span>
								</button>
								<span class="ms-2">{{ trait.name }}</span>
							</div>
						</td>
					</tr>
					</tbody>
				</table>
				<ng-template #nodata>
					<tbody>
					<tr>
						<td class="no-records" colspan="2" jhiTranslate="no.data"></td>
					</tr>
					</tbody>
				</ng-template>
			</div>
		</div>
	</div>
	<br>
	<div class="row">
		<div class="col-md-12 align-center">
			<button (click)="onNext()" [disabled]="!isNextEnabled()" class="btn btn-primary ms-2" jhiTranslate="next">Next</button>
		</div>
	</div>
</div>
